import React, { Component } from 'react';
import { Typography, Box } from '@mui/material';
import WorkdayLogo from '../Assets/Workday.png';

export class Thanks extends Component {
    static displayName = Thanks.name;
    render() {
        return (
            <div>
                <Typography variant="h4" align="Center" gutterBottom="true">
                    Thank you for your request!
                </Typography>
                <div>
                    <Typography paragraph align="Center">
                        We have received your request and will be in touch when your dosimeter is ready to pick up.
                    </Typography>
                    <Typography paragraph>
                        <span>
                            <ul>
                                <li style={{ listStyleType: 'none' }}>If you have not already done so: complete the <span><a href="https://wd5.myworkday.com/uasys/learning/course/76f169a3e8f410185f7f4ffdb9200000?record=479603b54bf8101bc3536e32dc710000&type=9882927d138b100019b928e75843018d">Personnel Monitoring for Radiation Exposure 101 Training</a></span> in Workday.</li>
                                <li style={{ listStyleType: 'none' }}>NOTE:  If you are not logged in to Workday, your UAMS My Apps page displays. Click the Workday icon (<Box
                                    component="img"
                                    sx={{
                                        height: 215,
                                        width: 215,
                                        maxHeight: 20,
                                        maxWidth: 20,
                                    }}
                                    alt="Workday Logo"
                                    src={WorkdayLogo}
                                />) to load the training.</li>
                            </ul>
                        </span>
                    </Typography>
                </div>
            </div>
        )
    }
}